import { create } from 'zustand';
import type { UserBadge } from '@the-wall/shared';
import { api } from '@/services/api';

type BadgeEntry =
  | { status: 'loading' }
  | { status: 'loaded'; badges: UserBadge[] }
  | { status: 'none' };

interface BadgeState {
  cache: Record<string, BadgeEntry>;
  loadBadges: (userId: string) => void;
  setBadgesForUser: (userId: string, badges: UserBadge[]) => void;
}

export const useBadgeStore = create<BadgeState>((set, get) => ({
  cache: {},

  loadBadges(userId) {
    const existing = get().cache[userId];
    if (existing) return;

    set((state) => ({
      cache: { ...state.cache, [userId]: { status: 'loading' } },
    }));

    api
      .getUserBadges(userId)
      .then((response) => {
        set((state) => ({
          cache: { ...state.cache, [userId]: { status: 'loaded', badges: response.badges } },
        }));
      })
      .catch(() => {
        set((state) => ({
          cache: { ...state.cache, [userId]: { status: 'none' } },
        }));
      });
  },

  setBadgesForUser(userId, badges) {
    set((state) => ({
      cache: { ...state.cache, [userId]: { status: 'loaded', badges } },
    }));
  },
}));
